const config = {
  backendUrl: "https://radian-360.wn.r.appspot.com",
  // ... other configuration settings ...
};

export default config;